import { Typography } from '@mui/material';
import React, { FC } from 'react';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { APIS } from '../../../../../../lib/constants/apis';
import { get } from 'lodash';

import Schema from '../../../../../../lib/paths/zuwendungsantrag_FULL_Paths.json';
import BescheidDownload from '../../../../../../components/ui-component/form-component/bescheid-download/BescheidDownload';
const P = Schema.attributes;

const AblehnungsBescheid: FC<{}> = () => {
	const { application } = useApplication();

	const bescheidPath = P.Bescheid_Bescheid.path;
	const bescheidDownloadOnPath = P.Freigabe_Uebermittlung_Heruntergeladen_Am.path;
	const bescheidDownloadStrapiFieldName = 'Freigabe_Uebermittlung_Heruntergeladen_Am';
	const apiName = APIS.Zuwendungsantrag;
	const apiObjectId = get(application, 'id');

	return (
		<>
			<Typography variant="h3">Ablehnungsbescheid</Typography>
			<BescheidDownload
				bescheidPath={bescheidPath}
				bescheidDownloadOnPath={bescheidDownloadOnPath}
				bescheidDownloadStrapiFieldName={bescheidDownloadStrapiFieldName}
				apiName={apiName}
				apiObjectId={apiObjectId}
			/>
		</>
	);
};
export default AblehnungsBescheid;
